import AboutCompany from "../../components/about-Company/about-compony.component"
import Footer from '../../components/footer/footer.component';

const AboutUs = ()=>{
    return(
        <div>
            <AboutCompany />
            <Footer />
        </div>
        
    )
}


export default AboutUs;